'use client'

import { useContentstackEditOverlay } from 'content-stack/hooks/useContentstackEditOverlay/useContentstackEditOverlay'
import { useInitLivePreview } from 'content-stack/hooks/useInitLivePreview/useInitLivePreview'

export interface ContentStackLivePreviewInitializerProps {
	readonly isSsr?: boolean
}

export function ContentStackLivePreviewInitializer({
	isSsr,
}: ContentStackLivePreviewInitializerProps) {
	const isInitialized = useInitLivePreview({ isSsr })
	useContentstackEditOverlay(isInitialized)

	return null
}
